import React from "react";
import { capitalize } from 'lodash';

const SimpleTableBadge = ({
  props,
  textPropKey,
  urlPropKey,
}) => {
  const label = capitalize(props[textPropKey]);
  const url = urlPropKey ? props[urlPropKey] : null;

  const badgeContent = (
    <span
      className="body-small-bold px-2 py-1"
      style={{
        backgroundColor: "#F7F9FC",
        borderRadius: "4px",
        cursor: url ? "pointer" : "default",
        color: "#000000",
      }}
    >
      {label}
    </span>
  );

  if (url) {
    return (
      <a
        href={url}
        onClick={(e) => {
          if (url.startsWith('/')) {
            e.preventDefault();
            window.location.href = url;
          }
        }}
        style={{
          textDecoration: 'none',
          color: 'inherit'
        }}
      >
        {badgeContent}
      </a>
    );
  }

  return badgeContent;
};

export default SimpleTableBadge;